import React, { useState, useEffect, useRef } from "react";

function ShoppingOrder() {

    return (
        <div className="pageContainer">
            <h1>購買訂單</h1>
        </div>
    );
}
export default ShoppingOrder;